import { Controller } from "@hotwired/stimulus";
import { Chart, registerables } from "chart.js";

// 管理画面の月別の販売状況で、販売上限額と入金済金額を月ごとの棒グラフで並べる。
// 値は ERB が data-sales-chart-*-value に JSON で渡し、Chart.js で描く。
// admin/data_analysis/monthly_sales_reports/show.html.erb から使う。

Chart.register(...registerables);

export class SalesChartController extends Controller {
  static values = { labels: Array, datasets: Array };

  connect() {
    this.chart = new Chart(this.element, {
      type: "bar",
      data: { labels: this.labelsValue, datasets: this.datasetsValue },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        scales: {
          y: { beginAtZero: true, ticks: { callback: (value) => `¥${Number(value).toLocaleString("ja-JP")}` } },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => `${context.dataset.label}: ¥${Number(context.parsed.y).toLocaleString("ja-JP")}`,
            },
          },
        },
      },
    });
  }

  disconnect() {
    this.chart?.destroy();
  }
}
